import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection({ eventCoalescing: true })], })
  .catch(err => console.error(err));

// add eruda console
; (function () {
  if (!/console=true/.test(window.location.href)) {
    return
  };

  (window as any).__initEruda = () => {
    const eruda = (window as any).eruda;
    if (!eruda) {
      setTimeout(function () { (window as any).__initEruda(); }, 200);
    } else {
      eruda.init();
    }
  }

  // add script to head tag
  const scriptEl: HTMLScriptElement = window.document.createElement('script');
  scriptEl.src = 'https://cdn.jsdelivr.net/npm/eruda';

  const scriptElinit: HTMLScriptElement = window.document.createElement('script');
  scriptElinit.innerText = 'setTimeout(function(){__initEruda();},200)';

  const headEl: HTMLHeadElement = window.document.getElementsByTagName('head')[0];
  headEl.appendChild(scriptEl);
  headEl.appendChild(scriptElinit);

})();
